import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import { swalDeleteForm, swalError, swalSmallForm, swalSuccess } from "../utils/swal";
import settingService from '../services/setting';
import Switch from "react-switch";

function ManageSimilarAds({
    session,
    setKey,
    ...props
}) {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showSimilarAds, setShowSimilarAds] = useState(true);

    useEffect(() => {
        settingService.get()
            .then(response => {
                if (response && response.data) {
                    setShowSimilarAds(response.data.showSimilarAds);
                }
            });
    }, []);

    const handleOnChange = checked => {
        setShowSimilarAds(checked);
        settingService.updateSimilarAds(session.token, checked)
            .then(response => {
                swalSuccess(t("setting_updated"));
            });
    }

    return (
        <div className="container">
            <div className="row mt-10">
                <div className="col text-left">
                    <h3>{t("manage_similar_ads_title")}</h3>
                </div>
            </div>
            <div className="row mt-10">
                <div className="col">
                    <p>{t("similar_ads_desc")}</p>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Switch onChange={handleOnChange} checked={showSimilarAds} />
                    <br />
                    {showSimilarAds && <p style={{ color: 'green' }}>{t("similar_ads_on_msg")}</p>}
                    {!showSimilarAds && <p style={{ color: 'red' }}>{t("similar_ads_off_msg")}</p>}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageSimilarAds);